import Vue from 'vue'
import { tecnico as routing } from '../util/routes'

export default {
  state: {
    tecnico: {},
    tecnicos: [],
    paginateTecnicos: {
      data: []
    },
    tecnicoPage: 1,
    tecnicoFilter: ''
  },
  mutations: {
    setTecnico: (state, payload) => {
      state.tecnico = payload
    },
    setTecnicos: (state, payload) => {
      state.tecnicos = payload
    },
    setPaginateTecnicos: (state, payload) => {
      state.paginateTecnicos = payload
    },
    setTecnicoPage: (state, payload = 1) => {
      state.tecnicoPage = payload
    },
    setTecnicoFilter: (state, payload = '') => {
      state.tecnicoFilter = payload
    }
  },
  actions: {
    async getPaginateTecnicos ({ commit, state }, payload) {
      commit('setPaginateTecnicos', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.tecnicoPage,
          filter: state.tecnicoFilter
        }
      })
      commit('setPaginateTecnicos', data)
    },
    async getTecnicos ({ commit }, payload) {
      commit('setTecnicos', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0,
          ...payload
        }
      })
      commit('setTecnicos', data)
    },
    async getTecnico ({ commit }, { id }) {
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setTecnico', data)
    },
    async postSaveTecnico ({ state }) {
      const { tecnico } = state
      if (tecnico.id) {
        return Vue.axios.put(`${routing}/${tecnico.id}`, tecnico)
      }
      return Vue.axios.post(`${routing}`, tecnico)
    },
    async deleteTecnico ({ state }) {
      const { tecnico } = state
      return Vue.axios.delete(`${routing}/${tecnico.id}`)
    }
  },
  getters: {
    tecnico: ({ tecnico }) => tecnico,
    tecnicoPage: ({ tecnicoPage }) => tecnicoPage,
    tecnicoFilter: ({ tecnicoFilter }) => tecnicoFilter,
    tecnicos: ({ tecnicos }) => tecnicos,
    paginateTecnicos: ({ paginateTecnicos }) => paginateTecnicos
  }
}
